import React from "react";
import { useLocation } from "react-router-dom";
import SEO from "@/components/SEO";
import { seoConfig } from "@/config/seo.config";

const SuccessDemo: React.FC = () => {
  const location = useLocation();

  const queryStringObj = Object.fromEntries(
    new URLSearchParams(location.search)
  );
  // Remove console.log for production
  const purpose = {
    title: "Scheduling a Demo",
    body: "scheduling a demo with us",
  };
  if (queryStringObj.requestedFor === "affiliate-program") {
    purpose.title = "Applying for our Affiliate Program";
    purpose.body = "applying for our Affiliate Program";
  }

  return (
    <>
      <SEO {...seoConfig.demoSuccess} />
      <main className="schedule-demo-new-parent-container my-12 text-gray-700">
        <section className="thank-you-container flex justify-center px-1 text-center items-center flex-col gap-5 mt-24">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="150"
            height="150"
            viewBox="0 0 256 256"
            fill="none"
          >
            <path
              d="M231.1 61.75L128.45 62L25.8 61.5H25.75C11.95 61.5 1 74.45 1 90.65V226.35C1 242.55 11.95 255.5 25.75 255.5H231.25C245.05 255.5 256 242.55 256 226.35V90.65C256 74.45 245.15 61.75 231.1 61.75ZM223.05 81.75L131.35 165.6L131 165.9L130.7 166.25C129.6 167.45 128.3 167.6 127.6 167.6C126.9 167.6 125.6 167.4 124.55 166.15L124.25 165.8L36.6 81.35L128.45 81.95L223.05 81.75ZM231.25 235.5H25.75C24 235.5 21 232.2 21 226.35V93.85L109.8 179.65C114.3 184.65 120.65 187.55 127.4 187.65H127.7C134.35 187.65 140.55 184.9 145.1 180.1L236.1 96.8V226.35C236 232.2 233 235.5 231.25 235.5Z"
              fill="url(#paint0_linear_1233_5457)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_1233_5457"
                x1="12"
                y1="158.5"
                x2="250.151"
                y2="158.5"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#9B0243" />
                <stop offset="0.35" stopColor="#C50054" />
                <stop offset="0.655" stopColor="#CE0058" />
                <stop offset="1" stopColor="#C70054" />
              </linearGradient>
            </defs>
          </svg>
          <h1 className="thank-you-heading mt-12 font-bold">
            Thank You for {purpose.title}
          </h1>
          <p className="thank-you-para">
            Thank you for {purpose.body}. We will get back to you shortly.
          </p>
          <p className="text-sm mt-2 mb-4">
            You should receive a confirmation email soon. Please check your inbox and spam folder.
          </p>
          <div className="flex gap-4">
            <button
              className="contained"
              onClick={() => (window.location.href = "/")}
            >
              Back to Home
            </button>
            <a 
              href="https://legittmateai.com/about" 
              className="outlined"
            >
              Learn More About Us
            </a>
          </div>
        </section>
      </main>
    </>
  );
};

export default SuccessDemo;
